import {
    FAVORITES_LOAD,
    FAVORITES_LOAD_ERROR,
    FAVORITES_RECEIVE,
    FAVORITES_ADD,
    FAVORITES_REMOVE,
    FAVORITES_SET_LOCAL_MODE,
    FAVORITES_SYNC_WITH_SERVER,
    FAVORITES_CLEAR_CLIENT,
    enforceMaxFavoriteCount
} from '../Actions/Favorites.action';

const DEFAULT_STATE = {
    items: [],
    loading: false,
    error: null,
    isLocalMode: false
};

export const favorites = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case FAVORITES_LOAD:
            return {
                ...state,
                loading: true,
                error: null
            };

        case FAVORITES_RECEIVE:
            return {
                ...state,
                loading: false,
                items: action.payload.items || [],
                error: null,
                isLocalMode: action.payload.isLocalMode || false
            };

        case FAVORITES_LOAD_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload.error
            };

        case FAVORITES_ADD:
            if (state.items.includes(action.payload.item)) {
                return state;
            }
            let newItems = enforceMaxFavoriteCount([...state.items, action.payload.item]);
            return {
                ...state,
                items: newItems
            };

        case FAVORITES_REMOVE:
            return {
                ...state,
                items: state.items.filter(item => item !== action.payload.item)
            };

        case FAVORITES_SET_LOCAL_MODE:
            return {
                ...state,
                loading: false,
                items: action.payload.items || [],
                error: null,
                isLocalMode: true
            };

        case FAVORITES_SYNC_WITH_SERVER:
            return {
                ...state,
                loading: false,
                items: action.payload.items || [],
                error: null,
                isLocalMode: action.payload.isLocalMode || false
            };

        case FAVORITES_CLEAR_CLIENT:
            return {
                ...state,
                items: [],
                isLocalMode: true
            };

        default:
            return state;
    }
};
